<template>
  <!-- 盒子/饰品升级-添加或编辑弹窗 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="dialogType === 1 ? '添加盒子' : '编辑盒子'"
      width="300px" @close="closeDialog">
      <el-form :model="formData" v-if="formData" ref="formData" label-width="80px" size="small" :rules="taskRules">
        <el-form-item prop="origin_id" label="选择盒子">
          <div class="prize-item" @click="visibleDialog = true" v-if="selectedData">
            <img :src="selectedData.origin_image" />
            <p class="goods-name">
              <span>{{ selectedData.origin_name }}</span>
            </p>
            <p class="goods-price">
              <span class="price">{{ selectedData.origin_price }}<img class="diamond"
                  style="vertical-align:middle;width:16px;height: 16px;" src="@/assets/img/diamond-icon.png" /></span>
            </p>
          </div>
          <div v-else class="add-prize" @click="visibleDialog = true">
            <i class="el-icon-plus"></i>
            <p>选择盒子</p>
          </div>
        </el-form-item>
        <el-form-item prop="upgrade_pro" label="升级概率">
          <el-input v-model="formData.upgrade_pro" placeholder="请输入升级概率"></el-input>
        </el-form-item>
        <el-form-item prop="origin_price" label="盒子价格">
          <el-input v-model="formData.origin_price" placeholder="请输入盒子价格"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="盒子状态">
          <el-select v-model="formData.status" placeholder="请选择盒子状态">
            <el-option :value="1" label="开启"></el-option>
            <el-option :value="0" label="关闭"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <BoxListDialog :visible="visibleDialog" @close="visibleDialog = false" @refresh="comebackData"></BoxListDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import BoxListDialog from './BoxListDialog.vue'
export default {
  components: {
    BoxListDialog
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeDialog: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visibleDialog: false,//盒子弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      formData: {//表单数据
        origin_id: '',
        upgrade_pro: '',
        origin_price: '',
        status: ''
      },
      selectedData: undefined,//选择的数据
      taskRules: {//表单验证
        origin_id: [
          {
            required: true,
            message: '请选择物品',
            trigger: 'blur'
          }
        ],
        upgrade_pro: [
          {
            required: true,
            message: '请输入升级概率',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择盒子状态',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeDialog
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.dialogInfo) {
        this.formData = this.dialogInfo
        this.selectedData = this.dialogInfo
      }

    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          if (this.formData.origin_price < 3) {
            this.$message.error("盒子价格最低3钻石")
            this.buttonLoading = false
            return
          }
          let params = this.formData
          if (this.dialogType == 1) {
            postApiData('upgrade_config', params).then(res => {
              if (res.code) {
                this.$message.success(res.message)
                this.closeDialog()//关闭弹窗
                this.$emit("refresh")//刷新数据
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType == 2) {
            patchApiData(`upgrade_config`, params).then(res => {
              if (res.code) {
                this.$message.success(res.message)
                this.closeDialog()//关闭弹窗
                this.$emit("refresh")//刷新数据
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    //获取选择物品后的反参
    comebackData(val) {
      let obj = {
        origin_id: val.id,
        origin_image: val.image,
        origin_name: val.name,
        origin_price: val.price,
      }
      this.selectedData = obj
      this.formData.origin_id = obj.origin_id
      this.formData.origin_price = obj.origin_price
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
      setTimeout(() => {
        if (this.dialogType == 2) {
          this.formData = {//还原任务表单
            origin_id: '',
            upgrade_pro: '',
            origin_price: '',
            status: ''
          }
          this.selectedData = undefined
        }
      }, 500)
    }
  }

}
</script>
<style lang="less" scoped>

</style>